import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { departmentListQueryOptions } from '@/features/organization/api/organization.api';
import { zonalManagerReportingToQueryOptions } from '@/features/users/api/users.api';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import {
  getDepartmentFilterField,
  getGeoFilterFields,
  getReportingMemberFilterField,
} from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';
import { SURVEY_SUBMISSION_REPORTING_TO_KEY } from '../constants/survey.constants';

interface SurveySubmissionFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function SurveySubmissionFilterPanel({ filters }: SurveySubmissionFilterPanelProps) {
  const { filterValues } = filters;

  const { data: departments } = useQuery(departmentListQueryOptions());
  const { data: reportingMembers } = useQuery(zonalManagerReportingToQueryOptions());
  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        ...getGeoFilterFields(filterValues, geoOptions),
        getDepartmentFilterField(departments),
        getReportingMemberFilterField(reportingMembers, SURVEY_SUBMISSION_REPORTING_TO_KEY),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
